const AdminConfig = require('./AdminConfig');

module.exports = {
  AdminConfig,
};
